import React, {useEffect, useState} from 'react';

import {
  Container,
  Content,
  FilterList,
  Filter,
  FilterText,
  Icon,
  FilterInfo,
  ContentHeader,
  FormFooter,
  Form,
} from './styles';
import {Header} from '../../../../../components/Interface/Headers/Header';
import {useNavigation, useRoute} from '@react-navigation/native';

import {Titles} from '../../../../../components/Interface/Typographies/Titles';

import {CidadeParceirosDTO} from '../../../../../dtos/ParceiroDTO';
import {RFValue} from 'react-native-responsive-fontsize';

import {LinkButton} from '../../../../../components/Interface/Forms/Buttons/LinkButton';
import {SearchInput} from '../../../../../components/Interface/Forms/Inputs/SearchInput';
import {NotFound} from '../../../../../components/Interface/Search/NotFound';
import {apiMasterClin} from '../../../../../services/api';
import {Loading} from '../../../../../components/Interface/Loadings/Loading';
import {Keyboard, TouchableWithoutFeedback} from 'react-native';

interface Params {
  cidade: number;
  bairro: number;
}

export function StoreFiltersNeighborhood() {
  const navigation = useNavigation();
  const route = useRoute();

  const [search, setSearch] = useState('');

  const [states, setStates] = useState<CidadeParceirosDTO[]>(
    [] as CidadeParceirosDTO[],
  );

  const [filteredStates, setFilteredStates] = useState<CidadeParceirosDTO[]>(
    [] as CidadeParceirosDTO[],
  );

  const {cidade, bairro} = route.params as Params;

  const selectedEstado = bairro;

  useEffect(() => {
    let isMounted = true;

    async function fetchStates() {
      await apiMasterClin
        .get('/endereco/cidades/' + cidade + '/bairros')
        .then(response => {
          const {data} = response.data;

          if (data) {
            if (isMounted) {
              setStates(data);
              isMounted = false;
            }
          }
        })
        .catch(({response}) => {
          const {mensagem} = response.data;

          if (mensagem) {
            navigation.navigate('ConfirmationScreen', {
              type: 'error',
              buttonAction: () => navigation.navigate('Initial'),
              buttonText: 'Ir para a tela inicial',
              closeIconAction: () => navigation.navigate('Initial'),
              text: mensagem,
              title: 'Ocorreu um problema',
            });
          } else {
            navigation.navigate('ConfirmationScreen', {
              type: 'error',
              buttonAction: () => navigation.navigate('Initial'),
              buttonText: 'Ir para a tela inicial',
              closeIconAction: () => navigation.navigate('Initial'),
              text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
              title: 'Ocorreu um problema',
            });
          }
        });
    }

    fetchStates();

    return () => {
      isMounted = false;
    };
  }, []);

  function handleNavigate(bairro: any) {
    navigation.navigate({
      name: 'StoreSearchFilters',
      params: {bairro},
      merge: true,
    });
  }

  function handleSearchCategories(name: string) {
    const filter = states.filter(e =>
      e.nome
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .includes(
          name
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, ''),
        ),
    );

    setFilteredStates(filter);
    setSearch(name);
  }

  function ordemAlfabetica(data: CidadeParceirosDTO[]) {
    return data.sort((a: any, b: any) => {
      if (
        a.nome.normalize('NFD').replace(/[\u0300-\u036f]/g, '') <
        b.nome.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      ) {
        return -1;
      }
      if (
        a.nome.normalize('NFD').replace(/[\u0300-\u036f]/g, '') >
        b.nome.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      ) {
        return 1;
      }
      return 0;
    });
  }
  return states.length !== 0 ? (
    <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
      <Container>
        <Header icon="chevron-left" action={() => navigation.goBack()} />

        <Content>
          <ContentHeader>
            <Titles title="Bairro" />
          </ContentHeader>

          <Form>
            <SearchInput
              placeholder="Buscar Bairro"
              value={search}
              autoCapitalize="sentences"
              onChangeText={text => handleSearchCategories(text)}
            />
            <FormFooter>
              <LinkButton
                text="Limpar filtro"
                enabled
                action={() => handleNavigate(undefined)}
              />
            </FormFooter>
          </Form>

          <FilterList
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{
              paddingBottom: RFValue(20),
            }}>
            {search.length !== 0 ? (
              filteredStates.length !== 0 ? (
                ordemAlfabetica(filteredStates).map((estado, index) => (
                  <Filter
                    style={{
                      borderBottomWidth:
                        index === filteredStates.length - 1 &&
                        filteredStates.length > 1
                          ? 0
                          : 1,
                    }}
                    activeOpacity={1}
                    onPress={() => handleNavigate(estado.id)}
                    key={estado.id}>
                    <FilterInfo>
                      <FilterText active={estado.id === selectedEstado}>
                        {estado.nome}
                      </FilterText>
                    </FilterInfo>
                    <Icon
                      name={
                        estado.id === selectedEstado ? 'check' : 'chevron-right'
                      }
                    />
                  </Filter>
                ))
              ) : (
                <NotFound />
              )
            ) : (
              ordemAlfabetica(states).map((estado, index) => (
                <Filter
                  style={{
                    borderBottomWidth:
                      index === states.length - 1 && states.length > 1 ? 0 : 1,
                  }}
                  activeOpacity={1}
                  onPress={() => handleNavigate(estado.id)}
                  key={estado.id}>
                  <FilterInfo>
                    <FilterText active={estado.id === selectedEstado}>
                      {estado.nome}
                    </FilterText>
                  </FilterInfo>
                  <Icon
                    name={
                      estado.id === selectedEstado ? 'check' : 'chevron-right'
                    }
                  />
                </Filter>
              ))
            )}
          </FilterList>
        </Content>
      </Container>
    </TouchableWithoutFeedback>
  ) : (
    <Loading />
  );
}
